import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Card, CardBody, Input } from 'reactstrap';

interface Props {
  value?: string;
  onChange?: (value: string) => void;
  name?: string;
  baseContent: string;
}

const StructuredInstructionField: React.FC<Props> = ({
  value = '',
  onChange,
  baseContent,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div>
      {baseContent && (
        <Card className="bg-light border mb-2">
          <CardBody className="py-2">
            <div className="text-muted small mb-1">
              <FormattedMessage
                id="app.views.ai.agents.agents_admin.structured_instruction_field.base_content_label"
                defaultMessage="Template default"
              />
            </div>
            <pre className="mb-0 small" style={{ whiteSpace: 'pre-wrap' }}>
              {baseContent}
            </pre>
          </CardBody>
        </Card>
      )}
      <Input
        type="textarea"
        rows={3}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={formatMessage({
          id: 'app.views.ai.agents.agents_admin.structured_instruction_field.placeholder',
          defaultMessage:
            'Add your customizations here (optional). These will take priority over the template defaults above.',
        })}
      />
    </div>
  );
};

export default StructuredInstructionField;
